import React from 'react';

import LoginContainer from './LoginContainer';
import SSOLoginForm from './SSOLoginForm';
import Locale from '../Translate/Locale';
import Heading1 from '../common/Heading1';

import styles from './SSOLoginPage.scss';

function LoginPage() {
  return (
    <LoginContainer>
      <div className={styles.loginBox}>
        <Heading1 styleName="title">Sign in to your organization</Heading1>
        <div className={styles.subTitle}>
          <Locale>Enter your organization namespace to continue</Locale>
        </div>
        <SSOLoginForm />
      </div>
    </LoginContainer>
  );
}

export default LoginPage;
